import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import sum from 'lodash/sum';
import values from 'lodash/values';
import keys from 'lodash/keys';
import ModalDialog from 'common/components/modal/modal_dialog';
import HorizontalBars from 'common/components/horizontal_bars';
import StarRating from 'common/components/star_rating';
import ProjectFeedback from 'common/containers/project_feedback';

/**
 * Project stats modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class StatsModal extends Component {
  componentDidMount() {
    this.props.fetchStatsIfNeeded();
  }

  render() {
    const { onClose, stats, project, onAdmin } = this.props;

    if (!stats) {
      return null;
    }

    const totalScores = sum(values(stats.scored_revisions))
    const scoresData = {
      title: `Scores (${totalScores} total)`,
      items: keys(stats.scored_revisions).map(score => ({
        label: <StarRating initialRate={parseInt(score)} readonly={true}/>,
        value: stats.scored_revisions[score]
      }))
    };

    const commentsData = {
      title: 'Comments',
      items: [
        { label: 'This Project', value: stats.client_commented_entries },
        { label: 'Average', value: stats.client_commented_entries_avg }
      ]
    };

    const entriesData = {
      title: 'Entries',
      items: [
        { label: 'This Project', value: stats.entries },
        { label: 'Average', value: stats.entries_avg }
      ]
    };

    const creativesData = {
      title: 'Creatives',
      items: [
        { label: 'This Project', value: stats.creatives },
        { label: 'Average', value: stats.creatives_avg }
      ]
    };

    const awardsData = {
      title: 'Awards',
      items: [
        { label: 'This Project', value: stats.total_awards, money: true },
        { label: 'Average', value: stats.total_awards_avg, money: true }
      ]
    };

    const watchersData = {
      title: 'Users watching this project',
      items: [
        { label: 'This Project', value: stats.watchers },
        { label: 'Average', value: stats.watchers_avg }
      ]
    };

    return (
      <ModalDialog modalOpen={true} modalHeader="Project Stats" dialogClasses="stats-modal"
          showClose={true} contentClasses="wide" closeAction={onClose}>
        <div>
          <h2>Insights About This Project</h2>

          <div className="row">
            <div className="column medium-8 small-16">
              <HorizontalBars data={scoresData} className="scores-graph" />
              <div className="highlighted">
                <div>Entries eliminated: { stats.eliminated_entries }</div>
                <div>Entries to be scored: { stats.unscored_entries }</div>
              </div>
            </div>
            <div className="column medium-7 small-16 info-block">
              <h4>
                { project.client_username }'s feedback
                is <ProjectFeedback project={project} showClientFeedback={true} />
              </h4>
              <p>
                The feedback score helps creatives decide which projects they want to work in.
                We know feedback is important and work hard to educate clients that comments and
                scores help them get the best results in their projects.
                A client can improve this score, increase participation in their project, and
                improve their reputation by scoring and commenting on all entries. The more scores
                and comments, the higher the feedback score.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="column medium-8 small-16">
              <HorizontalBars data={commentsData} placeInside={true} />
            </div>
            <div className="column medium-8 small-16">
              { onAdmin?
              <HorizontalBars data={entriesData} placeInside={true} /> :
              <HorizontalBars data={awardsData} placeInside={true} /> }
            </div>
          </div>

          <div className="row">
            <div className="column medium-8 small-16">
              <HorizontalBars data={creativesData} placeInside={true} />
            </div>
            <div className="column medium-8 small-16">
              { onAdmin?
              <HorizontalBars data={awardsData} placeInside={true} /> :
              <HorizontalBars data={watchersData} placeInside={true} /> }
            </div>
          </div>

          <div className="row">
            <div className="column large-8 small-16 info-block">
              <div className="highlighted">
                <h4>
                  client's ratings
                  <span className="pull-right">client's projects</span>
                </h4>
                <div>
                  Timing: { stats.client_timing_avg? `${stats.client_timing_avg} out of 5` : 'N/A' }
                  <span className="pull-right">{ stats.client_posted_projects }</span>
                </div>
                <div>
                  Communication: { stats.client_communication_avg?
                    `${stats.client_communication_avg} out of 5` : 'N/A'
                  }
                </div>
                <div>
                  Overall satisfaction: { stats.client_overall_satisfaction_avg?
                    `${stats.client_overall_satisfaction_avg} out of 5` : 'N/A'
                  }
                </div>
              </div>
            </div>
            { onAdmin &&
            <div className="column large-8 small-16">
              <HorizontalBars data={watchersData} placeInside={true} />
            </div> }
          </div>

          { stats.client_last_login &&
          <div className="row column small-16 info-block text-center">
            Client's last visit: { moment(stats.client_last_login).format('MMM D, YYYY, hh:mm a') }
          </div> }

        </div>
      </ModalDialog>);
  }
}


StatsModal.propTypes = {
  stats: PropTypes.object,
  project: PropTypes.object,
  onClose: PropTypes.func,
  fetchStatsIfNeeded: PropTypes.func,
  onAdmin: PropTypes.bool
};



// WEBPACK FOOTER //
// ./project/components/stats_modal.jsx